import { render, staticRenderFns } from "./公示公告 copy.vue?vue&type=template&id=2c85586a&scoped=true"
import script from "./公示公告 copy.vue?vue&type=script&lang=js"
export * from "./公示公告 copy.vue?vue&type=script&lang=js"
import style0 from "./公示公告 copy.vue?vue&type=style&index=0&id=2c85586a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85586a",
  null
  
)

export default component.exports